import { isEmpty } from 'lodash/fp';
import pt from 'prop-types';
import { Children, cloneElement, forwardRef, useMemo } from 'react';
import { mapIndexed, stubNull } from '@mews-commander/utils';
import { VectorDirection } from '@mews/enums';
import { MatrixBodyWrapperElement } from '../styles';

const renderVector =
    ({ parentNestedIndex, cellHeight, cellWidth, depth = 0, expanded, vectorDirection }: $TSFixMe) =>
    (vector: $TSFixMe, vectorIndex: $TSFixMe) => {
        const { subVectors = [] } = vector.props;

        const currentNestedIndex = parentNestedIndex ? `${parentNestedIndex}.${vectorIndex}` : vectorIndex.toString();
        const isCurrentRowExpanded = expanded[currentNestedIndex];

        return (
            <>
                {cloneElement(vector, {
                    cellHeight,
                    cellWidth,
                    depth,
                    key: `vector-${currentNestedIndex}`,
                    nestedIndex: currentNestedIndex,
                    vectorDirection,
                    vectorIndex,
                })}
                {isCurrentRowExpanded
                    ? mapIndexed(
                          renderVector({
                              cellHeight,
                              cellWidth,
                              depth: depth + 1,
                              expanded,
                              parentNestedIndex: currentNestedIndex,
                              vectorDirection,
                          }),
                          subVectors
                      )
                    : null}
            </>
        );
    };

export const matrixBodyFactory = ({
    MatrixBodyWrapper = MatrixBodyWrapperElement,
    BottomComponent = stubNull,
} = {}) => {
    const MatrixBody = forwardRef(
        // @ts-expect-error $TSFixMeError: Property 'handleScroll' does not exist on type '{ children?: ReactNode; }'.
        ({ children, handleScroll, cellHeight, cellWidth, expanded, vectorDirection, ...bodyProps }, ref) => {
            const matrixVectors = useMemo(() => {
                if (isEmpty(children)) {
                    return null;
                }

                return Children.map(children, renderVector({ cellHeight, cellWidth, expanded, vectorDirection }));
            }, [cellHeight, cellWidth, children, expanded, vectorDirection]);

            return matrixVectors ? (
                // @ts-expect-error $TSFixMeError: No overload matches this call.
                <MatrixBodyWrapper ref={ref} onScroll={handleScroll} vectorDirection={vectorDirection} {...bodyProps}>
                    {matrixVectors}
                    <BottomComponent />
                </MatrixBodyWrapper>
            ) : null;
        }
    );

    MatrixBody.propTypes = {
        // @ts-expect-error $TSFixMeError: Type '{ cellHeight: pt.Requireable<number | (number | null)[]>; cellWidth: pt.Requireable<number | (number | null)[]>; c...
        cellHeight: pt.oneOfType([pt.number, pt.arrayOf(pt.number)]),
        cellWidth: pt.oneOfType([pt.number, pt.arrayOf(pt.number)]),
        children: pt.node.isRequired,
        expanded: pt.shape({}),
        handleScroll: pt.func,
        vectorDirection: pt.oneOf([VectorDirection.Row, VectorDirection.Column]).isRequired,
    };

    return MatrixBody;
};

export default matrixBodyFactory();
